import React, {forwardRef} from "react";
import {css} from "@emotion/react";

import {Col} from "@pg-design/grid-module";

interface IProps {
    children?: React.ReactNode;
    "data-testid"?: string;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    dynamicProps?: Record<string, string | number>;
}

export const ColumnListItem = forwardRef<HTMLDivElement, IProps>((props, ref) => (
    <Col
        {...(props.dynamicProps || {})}
        ref={ref}
        id={props.id}
        data-testid={props["data-testid"]}
        sm={4}
        md={4}
        lg={4}
        style={props.style}
        className={props.className}
        as="li"
        css={colStyle}
    >
        {props.children}
    </Col>
));

/*
    Styles
 */
const colStyle = css`
    display: flex;
    justify-content: center;
`;
